import React from 'react'
import FbaItemDesignPage from './FbaItemDesignPage'
import '../styles/index.scss'

const FbaItemDesignContainer = () => {
    return (
        <div className='FbaItemDesignContainer'>
            <FbaItemDesignPage />
        </div>
    )
}

export default FbaItemDesignContainer
